import React from "react";
import { Section } from "@atoms/Section";
import Text from "@ds/components/Text";
import color from "@definitions/mui/color";
import { Box } from "@mui/material";
import { useTranslation } from "next-i18next";
import useAction from "@containers/About/hooks/useAction";
import useStyles from "../partial-styles";

interface IDigitalItem {
  icon: string;
  label: string;
  title: string;
}

const DigitalItem = ({ icon, label, title }: IDigitalItem) => {
  const classes = useStyles({ size: "lg" });

  return (
    <Box
      display="grid"
      gridTemplateColumns="64px 1fr"
      alignItems="center"
      gap="16px"
      className={classes.svgSize}
    >
      <Box mb={2}>
        <img src={icon} alt={title} width={64} height={64} />
      </Box>
      <Box>
        <Text
          variant="h4"
          sx={{
            fontSize: "16px",
          }}
        >
          {title}
        </Text>
        <Text
          weight="400"
          variant="body2"
          sx={{
            marginTop: "12px",
            color: color.inactive.secondary,
            lineHeight: "19px",
            display: "inline-block",
          }}
        >
          {label}
        </Text>
      </Box>
    </Box>
  );
};

const DigitalisasiPartial: React.FC = () => {
  const { t } = useTranslation("common");
  const { dataAbout } = useAction();

  return (
    <Section py="24px" variant="gray">
      <Text
        weight="700"
        variant="h3"
        sx={{
          marginBottom: "24px",
          lineHeight: "26px",
          textAlign: "center",
        }}
      >
        {t("about.uvp.title")}
      </Text>
      <Box
        sx={{
          "& > div": {
            "& + div": {
              marginTop: "24px",
            },
          },
        }}
      >
        {dataAbout.map((data, index) => (
          <DigitalItem key={index} icon={data.image} title={data.title} label={data.description} />
        ))}
      </Box>
    </Section>
  );
};

export default DigitalisasiPartial;
